<template>
    <div class="todayAdopt">
        <div class="title">
            今日已取用稿件
        </div>
        <div class="content" id="main" ></div>
    </div>
</template>

<script>
    var echarts = require('echarts')

    export default {
        name: "todayAdoptManuscript",
        data() {
            return {
                dataList: [],
                timer: null
            }
        },
        mounted() {
            this.getData();
            this.timer =setInterval(() => {
                this.getData();
            }, 1000*60*15);
        },
        methods: {
            getData(){
                this.axios.get('/bigscreen/todaytake.json').then(res => {
                    let data = res.data;
                    this.dataList = [];
                    for(var key in data.data){
                        this.dataList.push({
                            name: key,
                            value: data.data[key]
                        })
                    }
                    this.drawGraph(this.dataList);
                })
            },
            drawGraph(data){
                var chartDom = document.getElementById('main');
                var myChart = echarts.init(chartDom);
                var option;

                option = {
                    color: ['rgb(212,79,0)','rgb(0,255,255)','rgb(8,94,255)','rgb(149,82,249)'],
                    series: [
                        {
                        type: 'pie',
                        radius: [70, 120],
                        center: ['50%', '50%'],
                        data: data,
                        label: {
                            show: true,
                            position: 'outside',
                            normal: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: '28',
                                    width: 400,
                                },
                                emphasis: {
                                    show: true,
                                },
                                formatter: ' {b}\n{c}',
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: 40,
                                lineStyle: {
                                    width: 2,
                                }
                            }
                        },
                        right: 0,
                        left: 70,
                        top: -60,
                        }
                    ]
                };

                option && myChart.setOption(option);
            },
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .todayAdopt{
        color: #fff;
        width: 760px;
        margin-top:18px;

    }
    .todayAdopt .title{
        background: url("../../../assets/images/shareOrAdoptLab.png") center center no-repeat;
        background-size: 100% 100%;
        font-size: 42px;
        line-height: 67px;
        height: 67px;
        text-align: center;
        /*font-weight: bold;*/
        font-family: hyk1gj;
    }
    .todayAdopt .content {
        width: 700px;
        height: 500px;
    }

</style>
